<template>
  <analytics-sub-page
    title="Find & Combine Analytics"
    icon="piggy-bank"
    css-class="analytics-find-combine"
    default-label="Find & Combine"
    :section-specs="sectionSpecs"
  >
    <pension-metrics ref="pensionRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import PensionMetrics, { pensionMetricsSections } from '@/pages/analyticsFindCombine/PensionMetrics.vue';

const pensionRef = ref(null);

// PensionMetrics carves itself into three subsections (Signups, Found,
// Combined). The section descriptors live with the component so this tab and
// the homepage "Download all" capture stay in sync.
const sectionSpecs = pensionMetricsSections(pensionRef);
</script>
